import moment from 'moment';

/** "0.250000" -> "25%", "0.125" -> "12.5%" */
export function percent(rate) {
    if (rate === null || rate === undefined || rate === '') {
        return '–';
    }
    var n = Number(rate) * 100;
    if (isNaN(n)) {
        return String(rate);
    }
    return `${Number(n.toFixed(2))}%`;
}

/**
 * Coupon form percent -> API rate: "25" -> "0.25". Null unless a whole
 * percent from 1 to 100: V1 stores rates at 2dp, so 12.5 must be refused,
 * never rounded to 13.
 */
export function percentToRate(value) {
    var text = String(value === null || value === undefined ? '' : value).trim();
    if (!/^\d+(\.0*)?$/.test(text) || Number(text) < 1 || Number(text) > 100) {
        return null;
    }
    return (Number(text) / 100).toFixed(2);
}

/** "2026-08-01" or ISO instant -> "1 Aug 2026" */
export function shortDate(value) {
    if (!value) {
        return '–';
    }
    var m = moment(value);
    return m.isValid() ? m.format('D MMM YYYY') : String(value);
}

/** Inclusive benefit window; the lifetime sentinel 2099-12-31 reads as "no end". */
export function benefitWindow(startsOn, endsOn) {
    if (!startsOn && !endsOn) {
        return 'pending activation';
    }
    var end = endsOn === '2099-12-31' ? 'no end' : shortDate(endsOn);
    return `${shortDate(startsOn)} – ${end}`;
}

export function money(value) {
    if (value === null || value === undefined || value === '') {
        return '–';
    }
    var n = Number(value);
    return isNaN(n) ? String(value) : n.toFixed(2);
}

/** First-of-previous-month and first-of-this-month, the default simulation period. */
export function previousMonthPeriod(now) {
    var base = moment(now || undefined).startOf('month');
    return {
        start: base.clone().subtract(1, 'month').format('YYYY-MM-DD'),
        end: base.format('YYYY-MM-DD')
    };
}

export function durationLabel(coupon) {
    if (coupon.duration_type === 'lifetime') {
        return 'lifetime';
    }
    if (coupon.duration_type === 'once') {
        return 'one invoice';
    }
    var n = coupon.duration_count || 0;
    return `${n} ${coupon.duration_unit}${n === 1 ? '' : 's'}`;
}

/** "25% off for 3 months" / "10% off for life" / "50% off one invoice" — the coupon's terms in one phrase. */
export function couponTerms(coupon) {
    if (!coupon) {
        return '–';
    }
    var what = percent(coupon.percent_off) + ' off';
    if (coupon.scope === 'product') {
        what += ' selected products';
    }
    if (coupon.scope === 'user_type') {
        what += ' selected seat types';
    }
    if (coupon.duration_type === 'lifetime') {
        return `${what} for life`;
    }
    if (coupon.duration_type === 'once') {
        return `${what} one invoice`;
    }
    return `${what} for ${durationLabel(coupon)}`;
}

/** Bootstrap label class for promotion status / coupon state / client discount phase. */
export function labelClass(value) {
    switch (value) {
        case 'active':
        case 'current':
        case 'applied':
            return 'label label-success';
        case 'draft':
        case 'pending':
        case 'pending_activation':
        case 'scheduled':
        case 'upcoming':
            return 'label label-warning';
        case 'paused':
            return 'label label-info';
        default:
            return 'label label-default';
    }
}

/**
 * An API instant (ISO-8601, any offset) as the value of a datetime-local
 * input showing UTC wall time: '2026-08-01T00:00'.
 */
export function utcLocalInput(iso) {
    if (!iso) {
        return '';
    }
    var m = moment.utc(iso);
    return m.isValid() ? m.format('YYYY-MM-DDTHH:mm') : '';
}

/**
 * A datetime-local value entered as UTC wall time, as an explicit UTC
 * instant for the API: '2026-08-01T00:00' -> '2026-08-01T00:00:00Z'.
 */
export function utcPayload(localValue) {
    if (!localValue) {
        return null;
    }
    var m = moment.utc(localValue, 'YYYY-MM-DDTHH:mm', true);
    return m.isValid() ? m.format('YYYY-MM-DDTHH:mm:ss[Z]') : null;
}



// WEBPACK FOOTER //
// ./app/utils/discountFormat.js